import * as MessagesActionTypes from '../../actiontypes/messages';

export default function closeDialog() {
  return { type: MessagesActionTypes.CLOSE_DIALOG };
}